<template>
  <div class="piece-box inner-content volunteer-statistics">
    <div class="piece-box-title flex-box align-center">
      <div class="flex-grow">志工统计</div>
      <piece-tab v-model="type" :tabs="timeTypes"></piece-tab>
    </div>
    <div class="volunteer-statistics-table">
      <div class="volunteer-statistics-row volunteer-statistics-head volunteer-statistics-deep">
        <div class="volunteer-statistics-td">排名</div>
        <div class="volunteer-statistics-td">姓名</div>
        <div class="volunteer-statistics-td">时长（h）</div>
      </div>
      <div class="volunteer-statistics-body" v-if="list.length > 0">
        <div class="volunteer-statistics-row" :class="{'volunteer-statistics-deep': i % 2 == 1}" v-for="(item, i) in list" :key="i">
          <div class="volunteer-statistics-td">{{ i + 1 }}</div>
          <div class="volunteer-statistics-td">{{ item.name }}</div>
          <div class="volunteer-statistics-td">{{ item.time }}</div>
        </div>
      </div>
      <a-empty :image="emptyImage" v-else />
    </div>
  </div>
</template>

<script>
    import { Empty } from 'ant-design-vue';
    import pieceTab from "../../../../components/piece-tab";

    export default {
        name: "VolunteerStatistics",
        components: {
            pieceTab
        },
        props: {
            number: Array
        },
        data() {
            return {
                type: 1,
                emptyImage: Empty.PRESENTED_IMAGE_SIMPLE
            }
        },
        computed: {
            timeTypes() {
                const res = [
                    {
                        key: 1,
                        title: "服务时长",
                        count: []
                    },
                    {
                        key: 2,
                        title: "活动时长",
                        count: []
                    },
                    {
                        key: 3,
                        title: "培训时长",
                        count: []
                    },
                ];
                const number = this.number;
                if(number) {
                    res.forEach((item, i) => {
                       item.count = number[i] || [];
                    });
                }
                return res;
            },
            list() {
                let res = [];
                const item = this.timeTypes.find(t => t.key == this.type);
                if(item) {
                    res = item.count;
                }
                return res;
            }
        }
    }
</script>

<style lang="less">
.volunteer-statistics-table {
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  height: 224px;
}
.volunteer-statistics-body {
  flex: 1;
  min-height: 0;
  overflow: auto;
}
.volunteer-statistics-row {
  display: flex;
  align-items: center;
  text-align: center;
  height: 56px;
  &.volunteer-statistics-head {
    color: rgba(0,0,0,0.85);
    font-weight: bold;
  }
  &.volunteer-statistics-deep {
    background-color: @background-color-base;
  }
}
.volunteer-statistics-td {
  flex: 1;
}
</style>
